import { differenceInDays } from "date-fns";

export const getDaysLeftConfigFusion2 = (
  isOpen: boolean,
  closingDate: Date,
): {
  text: string;
  variant: string;
} => {
  const daysLeft = differenceInDays(closingDate, new Date());
  if (daysLeft >= 15) {
    return { text: `${daysLeft} Days Left`, variant: `bg-content-positive` };
  }
  if (daysLeft >= 6) {
    return { text: `${daysLeft} Days Left`, variant: `bg-content-warning` };
  }
  if (daysLeft >= 1) {
    return { text: `${daysLeft} Day${daysLeft === 1 ? '' : 's'} Left`, variant: `bg-content-negative` };
  }
  if (isOpen) {
    return { text: `Closing Today`, variant: `bg-content-negative` };
  }
  return { text: `Closed`, variant: `bg-content-informative` };
};
